module.exports = __webpack_public_path__ + "img/assessment.f52a97b6.svg";